import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import baseUrl from "../../../helpers/baseUrl";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import JoditEditor from 'jodit-react';

const FooterContents = () => {
  document.title = "Estarch | Footer Contents";

  // Refs for each editor
  const aboutUsRef = useRef(null);
  const privacyPolicyRef = useRef(null);
  const termsConditionsRef = useRef(null);
  const returnPolicyRef = useRef(null);

  // State for storing content
  const [footerContent, setFooterContent] = useState({
    aboutUs: "",
    privacyPolicy: "",
    termsConditions: "",
    returnPolicy: "",
  });

  const config = useMemo(() => ({
    readonly: false,
    placeholder: 'Start typing...',
    height: 400
  }), []);

  useEffect(() => {
    // Fetch initial data
    const fetchFooterContents = async () => {
      try {
        const { data } = await axios.get(`${baseUrl}/api/footer-contents`);
        setFooterContent(data);
      } catch (error) {
        console.error("Error fetching footer contents:", error);
      }
    };
    fetchFooterContents();
  }, []);

  // Handle change for each field
  const handleChange = (key, value) => {
    setFooterContent((prev) => ({ ...prev, [key]: value }));
  };

  // Handle form submission
  const handleSubmit = async () => {
    try {
      await axios.put(`${baseUrl}/api/footer-contents`, footerContent);
      alert("Footer contents updated successfully!");
    } catch (error) {
      console.error("Error updating footer contents:", error);
      alert("Failed to update footer contents.");
    }
  };


  return (
    <div className="page-content bg-white">
      <div className="container mx-auto p-6">
        <Breadcrumbs title="Estarch" breadcrumbItem="Footer Contents" />

        <div className="shadow-lg p-6 bg-gray-50 rounded-lg">
          <div className="flex justify-between items-center mb-4">
            <p className="text-xl font-bold">Footer Contents</p>
          </div>

          {/* About Us */}
          <div className="border shadow-lg mb-6 rounded-lg">
            <div className="bg-sky-950 text-white text-2xl py-3 px-4">
              <h2 className="text-2xl font-semibold text-white">About Us</h2>
            </div>
            <div className="p-4">
              <JoditEditor
                ref={aboutUsRef}
                value={footerContent.aboutUs}
                config={config}
                onBlur={(newContent) => handleChange("aboutUs", newContent)}
                onChange={(newContent) => handleChange("aboutUs", newContent)}
              />
            </div>
          </div>

          {/* Privacy & Policy */}
          <div className="border shadow-lg mb-6 rounded-lg">
            <div className="bg-sky-950 text-white text-2xl py-3 px-4">
              <h2 className="text-2xl font-semibold text-white">Privacy & Policy</h2>
            </div>
            <div className="p-4">
              <JoditEditor
                ref={privacyPolicyRef}
                value={footerContent.privacyPolicy}
                config={config}
                onBlur={(newContent) => handleChange("privacyPolicy", newContent)}
              />
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="border shadow-lg mb-6 rounded-lg">
            <div className="bg-sky-950 text-white text-2xl py-3 px-4">
              <h2 className="text-2xl font-semibold text-white">Terms & Conditions</h2>
            </div>
            <div className="p-4">
              <JoditEditor
                ref={termsConditionsRef}
                value={footerContent.termsConditions}
                config={config}
                onBlur={(newContent) => handleChange("termsConditions", newContent)}
              />
            </div>
          </div>

          {/* Return Policy */}
          <div className="border shadow-lg mb-6 rounded-lg">
            <div className="bg-sky-950 text-white text-2xl py-3 px-4">
              <h2 className="text-2xl font-semibold text-white">Return Policy</h2>
            </div>
            <div className="p-4">
              <JoditEditor
                ref={returnPolicyRef}
                value={footerContent.returnPolicy}
                config={config}
                onBlur={(newContent) => handleChange("returnPolicy", newContent)}
              />
            </div>
          </div>

          <button className="mt-4" onClick={handleSubmit}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default FooterContents;
